/**
 * "Can't open this document" card — the most common cause is a deep link to a
 * document that belongs to a DIFFERENT store/account than the one currently
 * active, or the document no longer exists. TKT-2026-00126.
 *
 * Extracted from StandardDetailPage (file-size split, behaviour unchanged).
 */

import { Store as StoreIcon } from "lucide-react";
import { PageContainer } from "@/components/layout/PageContainer";
import { Button } from "@/components/ui/button";

export function DocLoadErrorCard({
  currentStore,
  onBackToList,
}: {
  currentStore: string | null;
  onBackToList: () => void;
}) {
  return (
    <PageContainer>
      <div className="flex min-h-[60vh] items-center justify-center p-6">
        <div className="w-full max-w-md rounded-2xl border bg-card p-8 text-center shadow-apple-sm">
          <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-muted">
            <StoreIcon className="h-7 w-7 text-muted-foreground" />
          </div>
          <h2 className="mb-1.5 text-lg font-semibold text-foreground">
            เปิดเอกสารนี้ไม่ได้
          </h2>
          <p className="mb-1 text-sm text-muted-foreground">
            เอกสารนี้อาจอยู่ในร้านค้า/บัญชีอื่น ไม่ใช่ร้านที่คุณกำลังใช้งานอยู่
            {currentStore ? ` (ขณะนี้: ${currentStore})` : ""} หรือเอกสารนี้ไม่มีอยู่แล้ว
          </p>
          <p className="mb-5 text-xs text-muted-foreground">
            ลองสลับร้านค้าที่มุมซ้ายบน แล้วเปิดลิงก์อีกครั้ง · This document may belong to a
            different store/account{currentStore ? ` (currently: ${currentStore})` : ""}, or no
            longer exists. Switch stores (top-left) and reopen the link.
          </p>
          <div className="flex items-center justify-center gap-2">
            <Button variant="outline" size="sm" onClick={() => window.location.reload()}>
              ลองใหม่ · Retry
            </Button>
            <Button size="sm" onClick={onBackToList}>
              กลับไปหน้ารายการ · Back to list
            </Button>
          </div>
        </div>
      </div>
    </PageContainer>
  );
}
